import { useMemo } from "react";

import { getNavbarLinks, getRoutes } from "../../../config";
import type { NavbarProviderProps } from "../navbar.types";
import { NavbarContext } from "./navbar-provider.context";

export function NavbarProvider({
  renderAutocomplete,
  children,
  baseURL,
  user,
  onLogout,
  showNotification,
  favoriteVehicles = 0,
  unreadChats = 0,
  returnUrl = (url) => url,
  customGuestLinks,
  searchRightSlot,
  shouldOpenInSameWindow = true,
}: Readonly<NavbarProviderProps>) {
  const routes = getRoutes(baseURL);
  const { guestLinks, userLinks } = getNavbarLinks(baseURL);

  const value = useMemo(
    () => ({
      baseURL,
      renderAutocomplete,
      routes,
      user,
      onLogout,
      showNotification,
      favoriteVehicles,
      unreadChats,
      guestLinks: customGuestLinks ?? guestLinks,
      userLinks,
      returnUrl,
      searchRightSlot,
      shouldOpenInSameWindow,
    }),
    [
      baseURL,
      renderAutocomplete,
      routes,
      user,
      onLogout,
      showNotification,
      favoriteVehicles,
      unreadChats,
      guestLinks,
      userLinks,
      returnUrl,
      customGuestLinks,
      searchRightSlot,
      shouldOpenInSameWindow,
    ]
  );

  return (
    <NavbarContext.Provider value={value}>{children}</NavbarContext.Provider>
  );
}
